// Prospect Service Schema fields
export const prospectSchemaFields = [
  "commPreferences",
  "consents",
  "country",
  "createdAt",
  "createdBy",
  "updatedAt",
  "updatedBy",
  "dateOfBirth",
  "emailAddresses",
  "enrichmentData",
  "firstName",
  "language",
  "lastName",
  "legalAcceptances",
  "phoneNumbers",
];

// Array fields that need special bucket handling
export const prospectArrayFields = [
  "consents",
  "commPreferences",
  "emailAddresses",
  "phoneNumbers",
  "enrichmentData",
  "legalAcceptances",
];

// Wizard steps
export const steps = [
  "Select Data",
  "Config Details",
  "Schema",
  "Ingestion Mapper",
  "Create Prospect Mapper",
  "Enrich Consumer Mapper",
  "Review",
];

// Mapper types
export const mapperTypes = ["ingestion", "createProspect", "enrichConsumer"];

// AJV format options for schema builder
export const ajvFormatOptions = [
  "date",
  "time",
  "date-time",
  "iso-time",
  "iso-date-time",
  "duration",
  "uri",
  "uri-reference",
  "uri-template",
  "url",
  "email",
  "hostname",
  "ipv4",
  "ipv6",
  "regex",
  "uuid",
  "json-pointer",
  "relative-json-pointer",
  "byte",
  "int32",
  "int64",
  "float",
  "double",
  "password",
  "binary",
];

// Initial state values
export const initialFormValues = {
  hashIdentifier: "email",
  countryAttribute: "",
  dobAttribute: "",
  partnerName: "",
};

export const initialAgeRanges = {
  default: { min: 18, max: 120 },
};

export const initialAjvSchemas = {
  default: { type: "object", required: [], properties: {} },
};

export const initialArrayDefaults = {
  createProspect: {
    consents: [],
    commPreferences: [],
    legalAcceptances: [],
    enrichmentData: [],
  },
  enrichConsumer: {
    consents: [],
    commPreferences: [],
    legalAcceptances: [],
    enrichmentData: [],
  },
};

// Modal initial states
export const initialAddDefaultModal = {
  open: false,
  arrayField: "",
  value: "",
  granted: true,
  category: "",
  enrichmentType: "",
  commPreferenceType: "",
  mapperType: "createProspect",
};

export const initialEnrichmentModal = {
  open: false,
  mappingIndex: -1,
  category: "",
  enrichmentType: "",
};

export const initialModifierModal = {
  open: false,
  mappingIndex: -1,
  modifier: "",
};

export const initialCommPrefModal = {
  open: false,
  mappingIndex: -1,
  channel: "email",
  commPreferenceType: "",
  mapperType: "prospect",
};

export const initialConsentModal = {
  open: false,
  mappingIndex: -1,
  consentType: "",
  mapperType: "prospect",
};

export const initialPreviewModal = {
  open: false,
  title: "",
  originalData: null,
  mappedData: null,
  intermediateData: null,
};

export const initialSearchModal = {
  open: false,
  searchTerm: "",
  results: [],
  loading: false,
  error: null,
  selectedConfigId: "",
};

export const initialExportStatus = {
  loading: false,
  success: false,
  error: null,
};

// Enrichment categories and their corresponding types
export const ENRICHMENT_CATEGORIES = {
  Interest: [
    "brand_preferences",
    "passion_points",
    "favorite_soccer_team",
    "favorite_music_interest",
  ],
  Consumption: [
    "weekly_plus",
    "occasion_activity",
    "occasion_place",
    "purchase_decision",
    "purchase_location",
    "frequency",
  ],
  Demographic: ["age"],
  Business: ["company_name", "adobe_product_of_interest", "Additional_Information"],
  "Profile Source": ["Form Name"],
};
